/**
 * A person shown as a round chip: their profile photo when they have one,
 * otherwise their initials (Matt Farless = "MF"). The full name is the
 * tooltip and the accessible name, so nothing is lost by the short form.
 */
import { useState } from "react";
import { initialsFor } from "@truckbuddy/contract";

export function Avatar({
  name,
  userId,
  avatarVersion,
  size = "md",
  system = false,
  title,
}: {
  name: string;
  /** Needed for a photo; without it the chip always shows initials. */
  userId?: string | null;
  /** Null or absent means no photo. */
  avatarVersion?: string | null;
  size?: "sm" | "md" | "lg";
  /** Grey chip for the system or an import rather than a person. */
  system?: boolean;
  /** Tooltip; defaults to the name. */
  title?: string;
}) {
  const [failed, setFailed] = useState(false);
  const showPhoto = Boolean(userId && avatarVersion && !failed);
  return (
    <span
      className={`avatar avatar-${size}${system ? " avatar-system" : ""}`}
      role="img"
      aria-label={name}
      title={title ?? name}
      data-initials={initialsFor(name)}
    >
      {showPhoto ? (
        <img
          src={`/api/users/${userId}/avatar?v=${encodeURIComponent(avatarVersion!)}`}
          alt=""
          onError={() => setFailed(true)}
        />
      ) : (
        <span aria-hidden="true">{initialsFor(name)}</span>
      )}
    </span>
  );
}
